<script>
export const pageName = 'club-calendar-events-add-special';
export const pageRoute = '/clubs/{clubId}/{calendarId}/events/add-special';
export const title = 'Add Special Event'
export const requireMembership = true;

import { hideLoading, showLoading } from '../../js/utils/loading.js';
import { navigate } from '@trullock/page-manager'
import { commands } from '../../js/lib/functions.js';
import { showToast } from '../../js/utils/toast.js'
import { getClubCalendarView, getClubView } from '../../js/readModel.js';
import DateTime from '../../../functions/lib/dateTime.js';

export default {
	data() {
		return { 
			name: null,
			startsOnDate: null,
			startsOnTime: null,
			endsOnDate: null,
			endsOnTime: null,
			dateMin: null,
			dateMax: null,
			notes: null,
			isDirty: false,
			ready: false
		}
	},

	methods: {
		beforeHide() {
			return this.isDirty ? 'Are you sure you want to abandon your changes?' : null
		},
		async show(opts) {
			
			commands.warmUp.clubCalendarSpecialEventAdd();
			
			this.club = await getClubView(opts.clubId)
			this.calendar = await getClubCalendarView(opts.clubId, opts.calendarId);

			this.name = null;
			this.startsOnDate = DateTime.today.format('yyyy-MM-dd');
			this.startsOnTime = "10:00"
			this.endsOnDate = DateTime.today.format('yyyy-MM-dd');
			this.endsOnTime = "17:00"
			this.dateMin = new DateTime(this.calendar.year, 1, 1).format('yyyy-MM-dd');
			this.dateMax = new DateTime(this.calendar.year, 12, 31).format('yyyy-MM-dd');
			this.notes = null

			this.isDirty = false;
			this.ready = true;
		},
		changed() {
			this.isDirty = true;
		},
		async submit () {
			showLoading();

			let result = await commands.clubCalendarSpecialEventAdd({ 
				clubId: this.club.id,
				calendarId: this.calendar.id,
				name: this.name, 
				startsOn: new DateTime(this.startsOnDate + " " + this.startsOnTime),
				endsOn: new DateTime(this.endsOnDate + " " + this.endsOnTime),
				notes: this.notes
			});

			if(!result.success)
			{
				showToast({ message: 'Error adding event', style: 'bg-danger'})
				hideLoading();
				return;
			}

			this.isDirty = false;

			navigate(`/clubs/${this.club.id}`)

			showToast({
				message: 'Event added',
				style: 'bg-success'
			})

			hideLoading();
		}
	}
}

</script>
<template>
	<div v-show="ready" class="container py-5">
		<div class="row justify-content-center">
			<div class="col-12 col-md-8 col-xl-6 my-5">
				<h1 class="display-4 text-center mb-3">Add Special Event</h1>
				<p class="text-muted text-center mb-5">Add a new special event.</p>
					
				<form @submit.prevent="submit" @change="changed">
					<div class="form-group">
						<label class="form-label">Name</label>
						<input type="text" class="form-control" v-model="name" required autofocus>
						<span class="invalid-feedback"></span>
					</div>
					<div class="row">
						<div class="col-12 col-md-6">
							<div class="form-group">
								<label class="form-label">Start date</label>
								<input type="date" class="form-control" v-model="startsOnDate" :min="dateMin" :max="dateMax" required>
								<span class="invalid-feedback"></span>
							</div>
						</div>
						<div class="col-12 col-md-6">
							<div class="form-group">
								<label class="form-label">Start time</label>
								<input type="time" class="form-control" v-model="startsOnTime" required>
								<span class="invalid-feedback"></span>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-12 col-md-6">
							<div class="form-group">
								<label class="form-label">End date</label>
								<input type="date" class="form-control" v-model="endsOnDate" :min="dateMin" :max="dateMax" required>
								<span class="invalid-feedback"></span>
							</div>
						</div>
						<div class="col-12 col-md-6">
							<div class="form-group">
								<label class="form-label">End time</label>
								<input type="time" class="form-control" v-model="endsOnTime" required>
								<span class="invalid-feedback"></span>
							</div>
						</div>
					</div>
					
					
					<div class="form-group">
						<label class="form-label mb-1">Notes</label>
						<textarea class="form-control" v-model="notes" rows="4" required placeholder="The details that are special about this event"></textarea>
						<span class="invalid-feedback"></span>
					</div>

					<button class="btn w-100 btn-primary">Add event <span class="fe fe-check-circle"></span></button>
				</form>
			</div>
		</div>
    </div>
</template>
